export default __webpack_public_path__ + "static/media/About1.b0ba65fa.jpg";